import { API, Auth } from 'aws-amplify';
import * as constants from "../config/constants";
import * as types from "../actions/types";
import * as actions from "../actions";
import { getDeltaId, buildUserFromStudentService } from "./auth";
import { debugLog } from "./app";

// TODO secure student service spoofing
export async function fetchStudent(dispatch) {
  try {
    dispatch({type: types.FETCH_USER_REQUEST});
    const student = await API.get(
      'studentService',
      'student',
      {
        queryStringParameters:
          {
            deltaId: await getDeltaId(),
            sync: true
          }
      }
    );
    dispatch({type: types.FETCH_USER_SUCCESS});
    const user = buildUserFromStudentService(student);
    // if user isn't complete and isn't updating, it's a miss
    const status = user.complete || user.updating;
    return { status, user };
  } catch (e) {
    dispatch({type: types.FETCH_USER_FAILURE});
    if(typeof e.response === 'object' && e.response.status === 404) {
      debugLog('User not found');
      return { status: false, error: true, reason: constants.REASON_NOT_FOUND};
    }
    return { status: false, error: true, reason: e.message };
  }
}

export async function createStudent(dispatch) {
  dispatch({type: types.CREATE_USER_REQUEST});
  let user = await Auth.currentAuthenticatedUser();
  let deltaId = user.attributes['custom:deltaId'];
  const body = {
    deltaId
  };
  try {
    const result = await API.post("students", "students", { body, response: true });
    dispatch({type: types.CREATE_USER_SUCCESS});
    debugLog(result);
    if(result.status === 200 || result.status === 202) {
      if(result.data.complete)
        dispatch(actions.unsetNewUser());
      return {status: true, user: result.data};
    }
    return {status: false, reason: 'UNKNOWN'};
  } catch (e) {
    dispatch({type: types.CREATE_USER_FAILURE});
    console.error(e.response);
    return {status: false, reason: e.response};
  }
}

export async function fetchOptions(dispatch) {
  try {
    debugLog('Getting options');
    dispatch(actions.requestOptions());
    const options = await API.get("eops", "options/open", {});
    debugLog('Got options');
    dispatch(actions.receiveOptions(options));
  } catch (e) {
    console.error(e);
    dispatch(actions.addAlert('danger', 'Failed to get options: ' + e.message));
    dispatch(actions.requestOptionsFailure(e.message));
  }
}

export async function fetchOpenTerm(dispatch) {
  try {
    debugLog('Getting Open Term');
    dispatch(actions.requestOpenTerm());
    const term = await API.get("eops", "term/open", {});
    debugLog('Got Open Term');
    dispatch(actions.receiveOpenTerm(term));
  } catch (e) {
    if (e.response.status === 404) {
      dispatch(actions.addAlert('warning', 'EOPS does not currently have an open application period. ' +
        'Please check back later or contact the department for more application information.'));
      dispatch(actions.requestOpenTermFailure('EOPS does not currently have an open application period.'));
    } else {
      console.error(e);
      dispatch(actions.addAlert('danger', 'Failed to get open term: ' + (e.message ? e.message : e)));
      dispatch(actions.requestOpenTermFailure(e.message));
    }
  }
}

export async function fetchApplication(dispatch, deltaId, termApplying) {
  try {
    deltaId = typeof deltaId !== 'undefined' ? deltaId : await getDeltaId();
    debugLog('Fetching application ' + deltaId + ' - ' + termApplying);
    dispatch(actions.beginFetchApplication());
    const application = await API.get("eops", "form", { queryStringParameters: { deltaId, termApplying }});
    dispatch(actions.fetchApplicationSuccess(application));
    return { status: true, application }
  } catch (e) {
    // TODO fix to 404
    //if(typeof e.response === 'object' && e.response.status === 404) {
    if(typeof e.response === 'object' && e.response.data === 'Form does not exists') {
      debugLog('Application not found');
      dispatch(actions.fetchApplicationFailure('Application Does Not Exist'));
      return { status: false, reason: constants.REASON_NOT_FOUND};
    }
    dispatch(actions.fetchApplicationFailure(e.message));
    return { status: false, reason: e.message };
  }
}

export async function submitApplication(dispatch, application) {
  try {
    debugLog('Submitting Application');
    dispatch(actions.beginSubmitApplication());
    debugLog(application);
    const response = await API.post("eops", "form", { body: application });
    debugLog(response);
    dispatch(actions.submitApplicationSuccess(response));
    dispatch(actions.addAlert('success', 'Application Submitted'));
    return { status: true, response };
  } catch (e) {
    dispatch(actions.submitApplicationFailure(e.message));
    dispatch(actions.addAlert('danger', 'Application not Submitted: ' + e.message ));
    return { status: false, reason: e.message };
  }
}